import Config from 'services/Config/configService';

//
// The SkillControl logo, for the scenes that show it large (Welcome, Logout, NotAuthorized, the unhandled-error
// screen) and for the top bar.
//
export const getAppLogoUrl = (): string => `${Config.getImageURL()}/logo.svg`;

export const appLogoLargeSize: number = 128;
